import { getStoreSupportedLocales } from '@repo/utils';

export interface SupportedLocaleOption {
    id: string;
    name: string;
    isStorePreferred?: boolean;
    isCustomerPreferred?: boolean;
}

export const getSupportedLocaleOptions = (customerPreferredLocale?: string, storePreferredLocale?: string) => {
    const supportedLocales = getStoreSupportedLocales();

    return supportedLocales.map((supportedLocale) => ({
        ...supportedLocale,
        isStorePreferred: supportedLocale.id === storePreferredLocale,
        isCustomerPreferred: supportedLocale.id === customerPreferredLocale,
    }));
};

export const isSelectedLocaleValid = (supportedLocales: SupportedLocaleOption[], locale?: string) => {
    return supportedLocales.length < 2 || (Boolean(locale?.length) && supportedLocales.some(({ id }) => id === locale));
};
